import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;
export const UPLOADS_BASE = BACKEND_URL;

const api = axios.create({
  baseURL: API_BASE,
  headers: { 'Content-Type': 'application/json' },
});

// Add auth token + tenant slug to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  // Detect tenant slug from URL query param or localStorage
  const urlParams = new URLSearchParams(window.location.search);
  const slug = urlParams.get('tenant') || localStorage.getItem('tenant_slug') || '';
  if (slug) {
    config.headers['X-Tenant-Slug'] = slug;
  }
  return config;
});

// Handle 401
api.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('admin_token');
      localStorage.removeItem('admin_user');
      if (window.location.pathname.startsWith('/panel') &&
          window.location.pathname !== '/panel/login') {
        window.location.href = '/panel/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
